"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TaskPill = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var styled_1 = require("@hiyllo/ux/styled");
var react_native_1 = require("react-native");
var TaskCardPillInner = (0, styled_1.styledRN)(react_native_1.Pressable, function (_a) {
    var $theme = _a.$theme, withLabel = _a.withLabel;
    return ({
        backgroundColor: withLabel ? $theme.midground2 : $theme.midground1,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        height: 25,
        paddingLeft: 5,
        paddingRight: 5,
        borderRadius: 5,
        gap: 5,
        cursor: "pointer",
        fontSize: 12.5
    });
});
var TaskCardPillOuter = (0, styled_1.styledRN)(react_native_1.Pressable, function (_a) {
    var $theme = _a.$theme;
    return ({
        backgroundColor: $theme.midground1,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        height: 25,
        paddingLeft: 7.5,
        paddingRight: 0,
        borderRadius: 5,
        gap: 7.5,
        cursor: "pointer",
        fontSize: 12.5
    });
});
exports.TaskPill = react_1["default"].memo(function TaskPill(props) {
    if (props.label != null) {
        return ((0, jsx_runtime_1.jsxs)(TaskCardPillOuter, __assign({ onPress: props.onClick }, { children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, __assign({ style: { color: "white", fontFamily: "hiyllo" } }, { children: props.label })), (0, jsx_runtime_1.jsx)(TaskCardPillInner, __assign({ onPress: props.onClick, withLabel: true }, { children: props.children }))] })));
    }
    return ((0, jsx_runtime_1.jsx)(TaskCardPillInner, __assign({ onPress: props.onClick }, { children: props.children })));
});
